<template>
  <div>
    <!-- Photos -->
    <div class="mdc-layout-grid demo-grid section-privacy-security">
      <h3
        id="feature8"
        class="feature mdc-typography--headline3 text-color mb-3"
      >
        Experiențe fotografice, proiectate pentru zilele noastre
      </h3>
      <p data-scroll class="mdc-typography--body text-color font-weight-bold">
        Adăugați magia Google Foto la contul dvs.
      </p>
      <div class="mdc-layout-grid__inner">
        <!-- ROW 1-->
        <div
          class="mdc-layout-grid__cell grid-cell-square mdc-layout-grid__cell--span-4-desktop mdc-layout-grid__cell--span-8-tablet mdc-layout-grid__cell--span-4-phone"
        >
          <!-- CARD CONTENT -->
          <div
            class="card-content pane-content-square d-flex align-items-start flex-column"
          >
            <h6 class="mdc-typography--headline6 text-color">Conectați-vă</h6>
            <p
              class="mdc-typography--headline5 text-color font-weight-bold mb-auto"
            >
              Aduceți-vă conținutul mai ușor în Surfverse Studio.
            </p>
            <!-- <figure class="image-feature8-item1" role="img"></figure> -->
            <picture
              class="img-center align-items-center position-relative w-100 h-100"
            >
              <source
                srcset="/img/photos/connect.svg"
                media="(prefers-color-scheme: dark)"
                loading="lazy"
              />
              <source
                srcset="/img/photos/connect.svg"
                media="(prefers-color-scheme: light), (prefers-color-scheme: no-preference)"
                loading="lazy"
              />
              <img
                src="/img/photos/connect.svg"
                id="screenshot"
                loading="lazy"
              />
            </picture>
          </div>
          <!-- END CARD CONTENT -->
        </div>
        <div
          class="mdc-layout-grid__cell grid-cell-square mdc-layout-grid__cell--span-4-desktop mdc-layout-grid__cell--span-8-tablet mdc-layout-grid__cell--span-4-phone"
        >
          <!-- CARD CONTENT -->
          <div
            class="card-content pane-content-square p-5 d-flex align-items-start flex-column"
          >
            <h6 class="mdc-typography--headline6 text-color">Încărcați</h6>
            <p
              class="mdc-typography--headline5 text-color font-weight-bold mb-auto"
            >
              Postați fotografii și videoclipuri direct din biblioteca dvs.
              Google Foto.
            </p>
            <!-- <figure class="image-feature1-item1" role="img"></figure> -->
            <picture
              class="img-center align-items-center position-relative w-100 h-100"
            >
              <source
                srcset="/img/photos/upload.svg"
                media="(prefers-color-scheme: dark)"
                loading="lazy"
              />
              <source
                srcset="/img/photos/upload.svg"
                media="(prefers-color-scheme: light), (prefers-color-scheme: no-preference)"
                loading="lazy"
              />
              <img
                src="/img/photos/upload.svg"
                id="screenshot"
                loading="lazy"
              />
            </picture>
          </div>
          <!-- END CARD CONTENT -->
        </div>
        <div
          class="mdc-layout-grid__cell grid-cell-square mdc-layout-grid__cell--span-4-desktop mdc-layout-grid__cell--span-8-tablet mdc-layout-grid__cell--span-4-phone"
        >
          <!-- CARD CONTENT -->
          <div
            class="card-content pane-content-square p-5 d-flex align-items-start flex-column"
          >
            <h6 class="mdc-typography--headline6 text-color">Salvați</h6>
            <p
              class="mdc-typography--headline5 text-color font-weight-bold mb-auto"
            >
              Salvați rapid și sigur fotografii și videoclipuri în biblioteca
              dvs.
            </p>
            <!-- <figure class="image-feature1-item1" role="img"></figure> -->
            <picture
              class="img-center align-items-center position-relative w-100 h-100"
            >
              <source
                srcset="/img/photos/save.svg"
                media="(prefers-color-scheme: dark)"
                loading="lazy"
              />
              <source
                srcset="/img/photos/save.svg"
                media="(prefers-color-scheme: light), (prefers-color-scheme: no-preference)"
                loading="lazy"
              />
              <img src="/img/photos/save.svg" id="screenshot" loading="lazy" />
            </picture>
          </div>
          <!-- END CARD CONTENT -->
        </div>
        <!-- END ROW 1 -->
        <!-- ROW 2-->
        <div
          class="mdc-layout-grid__cell grid-cell mdc-layout-grid__cell--span-8-desktop mdc-layout-grid__cell--span-8-tablet mdc-layout-grid__cell--span-4-phone"
        >
          <!-- CARD CONTENT -->
          <div class="card-content pane-content p-5">
            <h6 class="mdc-typography--headline6 text-color">
              Confidențialitate și securitate
            </h6>
            <p class="mdc-typography--headline5 text-color font-weight-bold">
              Oferim utilizatorilor controlul asupra a ceea ce și când au acces
              Atunci când utilizatorii conectează unul dintre produsele sau
              serviciile dvs. cu Google Photos, noi întotdeauna vă cerem
              permisiunea. Vă puteți deconecta integrarea în orice moment.
            </p>
            <figure class="image-feature1-item1" role="img"></figure>
          </div>
          <!-- END CARD CONTENT -->
        </div>
        <div
          class="mdc-layout-grid__cell grid-cell mdc-layout-grid__cell--span-4-desktop mdc-layout-grid__cell--span-8-tablet mdc-layout-grid__cell--span-4-phone"
        >
          <!-- CARD CONTENT -->
          <div class="card-content pane-content p-5">
            <h6 class="mdc-typography--headline6 text-color">Public profile</h6>
            <p class="mdc-typography--headline5 text-color font-weight-bold">
              Introducing public and private profiles designed around security
              and privacy.
            </p>
            <figure class="image-feature1-item1" role="img"></figure>
          </div>
          <!-- END CARD CONTENT -->
        </div>
        <!-- END ROW 2 -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  Photos: 'Photos'
}
</script>

<style></style>
